<template>
    <Card>
        <template v-slot:title>
            {{ __('orders.by_type') }}
        </template>

        <table class="table table-sm table-hover table-vertical-center table-borderless m-0">
            <tbody>
            <tr v-for="orderTypeStatistics in statistics.orders_by_type"
                :key="orderTypeStatistics.type"
            >
                <td>
                    <OrderTypeBadge :type="orderTypeStatistics.type"/>
                </td>
                <td class="text-right text-lg w-150px">
                    {{ orderTypeStatistics.order_count }}&nbsp;{{ __('orders.orders') }}
                </td>
            </tr>
            </tbody>
        </table>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import OrderTypeBadge from "@components/Orders/OrderTypeBadge.vue";

export default {
    components: {OrderTypeBadge, Card},

    props: {
        statistics: Object
    }
}
</script>
